import { ModalContext, ModalProvider, ModalConsumer } from './context'
import Modal from './components/Modal'

export {
  ModalContext,
  ModalProvider,
  ModalConsumer,
  Modal
}
